import React from 'react'

export const LayoutContext = React.createContext({
  container: 'main',
})

export const NavigationContext = React.createContext({
  navigationItems: [],
  setNavigationItems: () => {},
})

export const reduceNavigationItems = (state, action) => {
  switch (action.type) {
    case 'add':
      return !state.find((el) => el.id === action.values[0].id)
        ? [...state, ...action.values]
        : state
    case 'remove':
      return state.find((el) => el.id === action.values)
        ? state.filter((el) => el.id !== action.values)
        : state
    case 'clear':
      return []
  }
}
